module.exports = __webpack_public_path__ + "static/media/canvasEnd.e2f9fc1d.jpg";